<div class="image-container">
	<ion-img #picture *ngIf="image() as image" [src]="image.File | imageSanitizer: image.MimeType" (ionError)="onError()">
	</ion-img>

	<ion-icon *ngIf="!image()" name="image">
	</ion-icon>
</div>